@if (statut) {
  <oui-tag type="status" [status]="getStatusColor()" size="big"> {{ getStatusText() }}</oui-tag>
}
